"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { Theme } from "~/theme";

const themeContext = createContext<Theme>({} as Theme);

export default function useTheme() {
  return useContext(themeContext);
}

export function ThemeProvider(props: { theme: Theme; children: ReactNode }) {
  return (
    <themeContext.Provider value={props.theme}>
      {props.children}
    </themeContext.Provider>
  );
}
